import { render } from "./ClientActivityComponent.vue?vue&type=template&id=41667d2e&scoped=true"
import script from "./ClientActivityComponent.vue?vue&type=script&lang=js"
export * from "./ClientActivityComponent.vue?vue&type=script&lang=js"

import "./ClientActivityComponent.vue?vue&type=style&index=0&id=41667d2e&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41667d2e"]])

export default __exports__
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLinearProgress,QBtn,QInnerLoading});
